// PlaceOrderDrawer.jsx
import {
    Box,
    Typography,
    TextField,
    Paper,
    CardMedia,
    Chip,
    InputLabel,
    IconButton
} from "@mui/material";
import { Trash2 } from "lucide-react";
import { pageStyles } from "../../Styles/pageStyles";
import { useTheme } from "@emotion/react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {currencyFormatter} from "@shared/Functions/apiHandler";

const CartProducts = ({ fuel, index, amount, priceChange, liters, deleteCart, handleLitersChange }) => {

    const theme = useTheme();
    const classes = pageStyles(theme);

    const deleteCartProduct = (fuel) => {
        let payload = {
            "productId": fuel?.product?.productId,
            "deliveryType": 1, // 1 - Delivery product, 2 - Pick up products
            "type": 2, // 1-Add To Cart, 2- Delete From Cart
            "name": fuel?.product?.name
        }
        deleteCart(payload);
    }

    return (
        <div>

            <Paper variant="outlined" sx={classes.paperDiv}>
                <Box sx={classes.flex_center_btn}>
                    <Box sx={classes.flex_c} key={index}>

                        <CardMedia
                            component="img"
                            image={fuel?.product?.imageUrl}
                            alt={fuel?.product?.imageUrl}
                            sx={classes.productImg}
                        />
                        
                        {fuel?.product?.purchaseType === 1 && 
                        <Box>
                            <Typography sx={classes.darkTextsmd500}> {fuel?.product?.name} </Typography>
                            <InputLabel sx={classes.darkTextSmall}> Min Order Qty: {fuel?.product?.minOrder} </InputLabel>
                            <InputLabel sx={classes.darkTextSmall}> Price: {currencyFormatter()}{fuel?.product?.price} / {fuel?.product?.measurement?.name} </InputLabel>
                        </Box>}

                        {fuel?.product?.purchaseType === 2 &&
                            <Box mt={1}>
                                <Typography sx={classes.darkTextsmd500}>
                                    {fuel?.product.name}
                                </Typography>

                                <Box sx={{ ...classes.flex_start, gap: 1 }}>

                                    {/* Minus Button */}
                                    <IconButton
                                        onClick={() => { handleLitersChange(index, 2) }}
                                        sx={classes.plusBtn}
                                    >
                                        <RemoveIcon sx={{ fontSize: 16 }} />
                                    </IconButton>


                                    {/* Number Display */}
                                    <Box sx={classes.numberDisplay}>
                                        <Typography
                                            variant="h6"
                                            sx={{ fontWeight: 500, color: "#000", fontSize: 15 }}
                                        >
                                            {liters}
                                        </Typography>
                                    </Box>

                                    <IconButton
                                        onClick={() => { handleLitersChange(index, 1) }}
                                        sx={classes.plusBtn}
                                    >
                                        <AddIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                </Box>
                            </Box>
                        }

                    </Box>

                    <Box sx={{ display: "flex", gap: 1 }}>

                        <Chip
                            label={fuel?.product?.stock > 0 ? "Available" : "Unavailable"}
                            size="small"
                            color="success"
                            sx={fuel?.product?.stock > 0 ? classes.avaiableBtn : classes.closedBtn}
                        />

                    </Box>
                </Box>


                {fuel?.product?.purchaseType === 1 &&
                    <Box mt={1}>
                        <InputLabel sx={classes.darkTextSmall}> Enter Amount </InputLabel>

                        <TextField
                            placeholder="₦0"
                            value={amount == 0 ? "" : amount}
                            onChange={priceChange}
                            size="small"
                            fullWidth
                            sx={classes.inputField}
                        />

                        {amount > 0 && <Typography sx={classes.lightTextsmd}>
                            You'll get {liters} {fuel?.product?.measurement?.name} @ ₦{amount}
                        </Typography>}
                    </Box>}




                <Box sx={{ textAlign: "right", mt: 1 }} >
                    <Trash2
                        size={16}
                        color="#DD0404"
                        cursor={"pointer"}
                        onClick={() => { deleteCartProduct(fuel) }}
                    />
                </Box>
            </Paper>
        </div>
    )
}

export default CartProducts
